import { render } from "./AdminCreators.vue?vue&type=template&id=4e7770fa&scoped=true"
import script from "./AdminCreators.vue?vue&type=script&lang=js"
export * from "./AdminCreators.vue?vue&type=script&lang=js"

import "./AdminCreators.vue?vue&type=style&index=0&id=4e7770fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7770fa"]])

export default __exports__